import styled from 'styled-components';
import { Col, Container, Row } from 'components/atoms/Grid';
import Colors from 'components/tokens/Colors';
import Text from 'components/atoms/Text';
import Button from 'components/atoms/Button';
import { sbEditable } from '@storyblok/storyblok-editable';
import { useEffect, useState } from 'react';
import RouterLink from 'components/atoms/RouterLink';
import { useEditor } from 'providers/generalContext';
import { gql } from 'apollo-boost';
import { useQuery } from '@apollo/client';

const query = gql`
    query {
        ArtigoacademicoItems(per_page: 3, sort_by: "content.year:DESC,name:ASC") {
            items {
                name
                slug
                uuid
                content {
                    authors
                    year
                }
            }
        }
    }
`;

export default function AcademicArchive(props) {
    const [articles, setArticles] = useState([]);
    const { isStoryblokEditor } = useEditor();
    const { data } = useQuery(query);

    useEffect(() => {
        setArticles(data?.ArtigoacademicoItems.items);
    }, [data]);

    return (
        <MainContent {...sbEditable(props)}>
            <Container style={{ position: 'relative' }}>
                <Row pt="8 12" pb="8 9">
                    <Col mb="5" size="12" px="1.5 4">
                        <Row justifyContent="space-between">
                            <Col size="12 auto">
                                <Row>
                                    <Col size="12" mb="2">
                                        <Text size="32 48" lineHeight="30 40" title hover>
                                            {props?.title}
                                        </Text>
                                    </Col>
                                    <Col size="12 hidden">
                                        <Divider light />
                                    </Col>
                                    <Col size="hidden 12">
                                        <Divider />
                                    </Col>
                                </Row>
                            </Col>
                            <Col size="hidden auto">
                                <RouterLink to="/educacao/achado" editor={isStoryblokEditor}>
                                    <Button dark inline {...sbEditable(props.button)}>
                                        {props?.button}
                                    </Button>
                                </RouterLink>
                            </Col>
                        </Row>
                    </Col>
                    <Col size="hidden 7" px="4" mb="5">
                        <Text body2>{props?.description}</Text>
                    </Col>
                    <Col size="12" px="1.5 4" mb="2 0">
                        <Row alignItems="stretch">
                            {articles?.map((card, key) => (
                                <Col size="12 4" mb="3" key={`${card?.uuid}-${key}`}>
                                    <RouterLink
                                        to={`/educacao/achado/${card?.slug}`}
                                        decoration="none"
                                        editor={isStoryblokEditor}
                                    >
                                        <Cards>
                                            <CardsHeader />
                                            <StyledContentCard
                                                pt="5"
                                                pb="5"
                                                direction="column"
                                                justifyContent="space-between"
                                            >
                                                <Col size="auto" px="2.5" mb="3">
                                                    <Text heading5>{card?.name}</Text>
                                                </Col>
                                                <Col size="auto" px="2.5">
                                                    <Text
                                                        body2
                                                        highlight
                                                        key={`author-${key}`}
                                                        style={{ display: 'block' }}
                                                    >
                                                        {card?.content?.authors}
                                                    </Text>

                                                    <Text body2>{card?.content?.year}</Text>
                                                </Col>
                                            </StyledContentCard>

                                            <CardsButton>Saiba mais</CardsButton>
                                        </Cards>
                                    </RouterLink>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                    <Col size="12 hidden" px="1.5">
                        <RouterLink to="/educacao/achado" editor={isStoryblokEditor}>
                            <Button dark {...sbEditable(props.button)}>
                                {props?.button}
                            </Button>
                        </RouterLink>
                    </Col>
                </Row>
            </Container>
        </MainContent>
    );
}

const MainContent = styled.div`
    position: relative;
    width: 100%;
    background-color: ${Colors.white};
`;

const Divider = styled.div`
    height: 2px;
    background-color: ${({ light }) => (light ? Colors.lightGrey : Colors.black)};
    width: ${({ light }) => (light ? '20%' : '35%')};
`;

const Cards = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${Colors.lightGrey};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const CardsHeader = styled.div`
    width: 100%;
    height: 8px;
    background-color: ${Colors.educationBlue};
`;

const CardsButton = styled.div`
    opacity: 1;
    width: 100%;
    padding: 9px 0;
    background-color: ${Colors.educationBlue};
    display: flex;
    justify-content: center;
    color: ${Colors.white};
    font-weight: bold;
    transition: opacity 200ms;
    user-select: none;

    &:hover {
        cursor: pointer;
        opacity: 0.8;
    }
`;

const StyledContentCard = styled(Row)`
    flex-grow: 1;
`;
